(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var CARD_SELECTOR = '.oddit-section-ugc-carousel__card';

  function sanitizeClone(node) {
    node.setAttribute('aria-hidden', 'true');
    var all = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      el.removeAttribute('id');
      el.removeAttribute('data-setting-id');
      var cls = (el.getAttribute('class') || '')
        .split(/\s+/)
        .filter(function (c) {
          return c && c.indexOf('oddit-reveal') !== 0 && c !== 'is-active';
        })
        .join(' ');
      if (cls) el.setAttribute('class', cls);
      else el.removeAttribute('class');
      if (el.style) {
        el.style.opacity = '';
        el.style.transform = '';
      }
    }
    var focusable = node.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    for (var f = 0; f < focusable.length; f++) {
      focusable[f].setAttribute('tabindex', '-1');
    }
    return node;
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    if (!track) return;
    if (section._odditTeardown) section._odditTeardown();

    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var dotsWrap = section.querySelector('.oddit-section-ugc-carousel__dots');
    var dots = [];

    var reals = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
    var N = reals.length;
    if (!N) return;

    // Layout: SETS clone sets, the reals, SETS clone sets. Two either side, not
    // one: with centre alignment a single set runs out before the wrap and the
    // last cards clamp against the end of the strip instead of centring.
    var SETS = N > 1 ? 2 : 0;
    var clones = [];
    if (SETS) {
      var firstReal = reals[0];
      for (var set = 0; set < SETS; set++) {
        reals.forEach(function (card) {
          var lead = sanitizeClone(card.cloneNode(true));
          clones.push(lead);
          track.insertBefore(lead, firstReal);
          var trail = sanitizeClone(card.cloneNode(true));
          clones.push(trail);
          track.appendChild(trail);
        });
      }
    }
    var slides = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));

    // One dot per slide, cloned from the single dot in the markup so the SVG
    // stays authored there rather than built in script.
    var dotTemplate = dotsWrap && dotsWrap.querySelector('[data-carousel-dot]');
    if (dotTemplate) {
      dotsWrap.innerHTML = '';
      for (var dn = 0; dn < N; dn++) {
        var dot = dotTemplate.cloneNode(true);
        dot.setAttribute('data-carousel-dot', String(dn));
        dot.setAttribute('aria-label', 'Slide ' + (dn + 1));
        dot.setAttribute('aria-selected', 'false');
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    // The design rests on the middle card of the set.
    var start = Math.floor(N / 2);
    var origin = SETS * N;
    var currentDom = origin + start;
    var settleTimer = null;
    var resizeTimer = null;
    var adjustTimer = null;
    var navEndTimer = null;
    var animFrame = null;
    var NAV_DURATION = 450;
    var reduceMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var signal = ctrl ? { signal: ctrl.signal } : undefined;

    function busy() {
      return track.classList.contains('is-dragging') ||
        track.classList.contains('is-settling') ||
        animFrame !== null;
    }

    // Measured off rects rather than offsetLeft: offsetLeft is relative to the
    // offsetParent, which is not the track's scroll origin once the track is
    // laid out full-bleed.
    function posOf(domIndex) {
      var s = slides[domIndex];
      if (!s) return 0;
      var box = track.getBoundingClientRect();
      var card = s.getBoundingClientRect();
      return track.scrollLeft + (card.left - box.left) - (box.width - card.width) / 2;
    }

    function nearestDom() {
      var box = track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var card = slides[i].getBoundingClientRect();
        var dist = Math.abs(card.left + card.width / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function logicalIndex(domIndex) {
      if (N < 2) return 0;
      return ((domIndex - origin) % N + N) % N;
    }

    // Distance forward from the slide the design rests on, 0..N-1.
    function relOf(domIndex) {
      return ((logicalIndex(domIndex) - start) % N + N) % N;
    }

    // The design draws fewer dots than there are slides, so each dot stands for
    // a group of them. Grouping keeps the run monotonic — mapping 5 slides onto
    // 3 dots any other way makes the cycle restart on the second or third dot.
    function dotOf(domIndex) {
      return Math.floor(relOf(domIndex) * (dots.length || 1) / N);
    }

    function paint(domIndex) {
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === domIndex);
      }
      var dotIndex = dotOf(domIndex);
      for (var d = 0; d < dots.length; d++) {
        var isActive = d === dotIndex;
        dots[d].classList.toggle('oddit-section-ugc-carousel__dot--active', isActive);
        dots[d].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    // Instant reposition with snap + smooth suspended for a frame, so the snap
    // engine cannot yank the jump to its own nearest snap point. The suspension
    // is a class, not inline styles — overlapping calls would otherwise save and
    // restore each other's temporary values.
    function setScrollInstant(pos) {
      track.classList.add('is-adjusting');
      track.scrollLeft = pos;
      var release = function () {
        track.classList.remove('is-adjusting');
      };
      requestAnimationFrame(release);
      // rAF is paused in a hidden tab; a timer keeps snap from staying off.
      clearTimeout(adjustTimer);
      adjustTimer = setTimeout(release, 200);
    }

    function goTo(domIndex) {
      // Rapid clicks can outrun the at-rest normalize; the strip is the limit.
      currentDom = Math.max(0, Math.min(domIndex, slides.length - 1));
      // Growing the new active card reflows the track, and mandatory snap
      // re-snaps on that reflow — which cancels the move we are about to make.
      // Snap stays off until the scroll has landed.
      track.classList.add('is-navigating');
      clearTimeout(navEndTimer);
      paint(currentDom);

      if (animFrame !== null) {
        cancelAnimationFrame(animFrame);
        animFrame = null;
      }

      if (reduceMotion && reduceMotion.matches) {
        endNav();
        setScrollInstant(posOf(currentDom));
        return;
      }

      // The active card changes size as it moves, so the centred position is a
      // moving target — a one-shot scrollTo would aim at a stale offset and land
      // off-centre, leaving normalize to snap it straight. Stepping the scroll
      // ourselves re-measures every frame, so the growth and the travel finish
      // together.
      var from = track.scrollLeft;
      var startedAt = null;
      var step = function (now) {
        if (startedAt === null) startedAt = now;
        var t = Math.min(1, (now - startedAt) / NAV_DURATION);
        var eased = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (posOf(currentDom) - from) * eased;
        if (t < 1) {
          animFrame = requestAnimationFrame(step);
          return;
        }
        animFrame = null;
        normalize();
      };
      animFrame = requestAnimationFrame(step);

      // rAF is paused in a hidden tab; land the move anyway so snap comes back.
      navEndTimer = setTimeout(function () {
        if (animFrame === null) return;
        cancelAnimationFrame(animFrame);
        animFrame = null;
        normalize();
      }, NAV_DURATION + 400);
    }

    // Only ever runs at rest: pulls a clone back to its real twin, and re-centres
    // after the active card has changed size.
    // Idempotent: re-running it on the scrollend its own jump produces lands on
    // the same slide and writes the same offset, so the chain stops by itself.
    function endNav() {
      clearTimeout(navEndTimer);
      track.classList.remove('is-navigating');
    }

    function normalize() {
      if (busy()) {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 60);
        return;
      }
      endNav();
      var nearest = nearestDom();
      // Whole sets are identical, so re-anchoring to the middle set is a
      // relabelling, not a move.
      var next = SETS ? origin + logicalIndex(nearest) : nearest;
      var relabelOnly =
        next !== currentDom && logicalIndex(next) === logicalIndex(currentDom);
      currentDom = next;
      if (relabelOnly) track.classList.add('is-relabelling');
      track.classList.add('is-adjusting');
      paint(currentDom);
      void track.offsetWidth;
      setScrollInstant(posOf(currentDom));
      track.classList.remove('is-relabelling');
    }

    var dragOrigin = null;
    var captureOpts = ctrl ? { capture: true, signal: ctrl.signal } : true;

    function handleDragStart() {
      dragOrigin = track.scrollLeft;
    }

    function handleDragRelease() {
      var from = dragOrigin;
      dragOrigin = null;
      if (from === null) return;
      if (!track.classList.contains('is-dragging')) return;
      if (Math.abs(track.scrollLeft - from) <= 1) return;
      resetAutoplay();
      goTo(nearestDom());
    }

    track.addEventListener('pointerdown', handleDragStart, signal);
    window.addEventListener('pointerup', handleDragRelease, captureOpts);
    window.addEventListener('pointercancel', handleDragRelease, captureOpts);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        resetAutoplay();
        goTo(currentDom - 1);
      }, signal);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        resetAutoplay();
        goTo(currentDom + 1);
      }, signal);
    }

    for (var i = 0; i < dots.length; i++) {
      (function (dot, idx) {
        dot.addEventListener('click', function () {
          resetAutoplay();
          // First slide of that dot's group, reached from where we are now so
          // the loop never scrolls the long way round.
          var rel = Math.ceil(idx * N / (dots.length || 1));
          goTo(currentDom + (rel - relOf(currentDom)));
        }, signal);
      })(dots[i], i);
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', normalize, signal);
    } else {
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 140);
      }, ctrl ? { passive: true, signal: ctrl.signal } : { passive: true });
    }

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        track.classList.add('is-adjusting');
        paint(currentDom);
        void track.offsetWidth;
        setScrollInstant(posOf(currentDom));
      }, 120);
    }, signal);

    // Autoplay
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        if (!busy()) goTo(currentDom + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (autoplayEnabled) {
      startAutoplay();
      section.addEventListener('mouseenter', stopAutoplay, signal);
      section.addEventListener('mouseleave', startAutoplay, signal);
      section.addEventListener('focusin', stopAutoplay, signal);
      section.addEventListener('focusout', startAutoplay, signal);
    }

    paint(currentDom);
    setScrollInstant(posOf(currentDom));
    // Re-align once the fonts and images have settled the real widths.
    requestAnimationFrame(function () {
      setScrollInstant(posOf(currentDom));
    });

    section._odditTeardown = function () {
      if (ctrl) ctrl.abort();
      stopAutoplay();
      clearTimeout(settleTimer);
      clearTimeout(resizeTimer);
      clearTimeout(adjustTimer);
      clearTimeout(navEndTimer);
      if (animFrame !== null) cancelAnimationFrame(animFrame);
      clones.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
      section._odditTeardown = null;
    };
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section && section._odditTeardown) section._odditTeardown();
  });
})();
